// src/App.js
import React, { useState } from 'react';
import SearchText from './SearchText';
import SearchFace from './SearchFace';
import ResultsGallery from './ResultsGallery';
import HighlightsCarousel from './HighlightsCarousel'; // <-- ¡NUEVA LÍNEA!
import { Mail, MessageCircle, Instagram } from 'lucide-react'; // <-- ¡NUEVOS ÍCONOS!
import './App.css';

function App() {
    const [activeTab, setActiveTab] = useState('text');
    const [searchResults, setSearchResults] = useState(null);
    const MERCADO_PAGO_LINK = "https://link.mercadopago.com.mx/fotorun"; // Tu Link de Pago

    // CONFIGURACIONES DE LA GALERÍA

    const GAL_TITTLE = "WeTribe Galentines"; // TITULO DE LA GALERÍA
    const GAL_DATE = "15 DE FEBRERO 2026"; // FECHA DEL EVENTO
    const GAL_END = "28 DE FEB 2026"; // FECHA FINAL DE LA GALERÍA

    
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const S3_HOST = process.env.REACT_APP_S3_HOST;

    const handleResults = (results) => {
        setSearchResults(results);
        setTimeout(() => {
            const gallery = document.getElementById('results-gallery-container');
            if (gallery) {
                gallery.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    return (
        <div className="App">
            <header className="app-header-container">
                {/* 1. Imagen de Fondo (div con posición absoluta) */}
                <div
                    className="app-header-background"
                    style={{ backgroundImage: `url("/images/bg-header.jpg")` }}
                ></div>

                {/* 2. Contenido del Encabezado (texto, logo, etc.) */}
                <div className="app-header-content">
                    <img
                        src="/Logotipo-FotoRun.svg"
                        alt="FOTORUN - Capturando tus logros"
                        className="header-logo"
                    />
                    <h1>capturando tus logros</h1>

                    <div className="event-info">
                        <h2>{GAL_TITTLE}</h2>
                        <span>{GAL_DATE}</span>
                    </div>
                </div>
            </header>

            <div className="container">
                <h1 className='titulo'>Busca tus fotos</h1>
            
                <div className="tabs-container">
                <button
                    className={`tab ${activeTab === 'text' ? 'active' : ''}`}
                    onClick={() => setActiveTab('text')}>
                    # DE CORREDOR
                </button>
                <button
                    className={`tab ${activeTab === 'face' ? 'active' : ''}`}
                    onClick={() => setActiveTab('face')}>
                    BÚSQUEDA FACIAL
                </button>
                </div>
            </div>
            

            <div className="search-content">
                {activeTab === 'text' && (
                    <SearchText
                        apiUrl={`${API_BASE_URL}/search`}
                        onResults={handleResults}
                    />
                )}
                {activeTab === 'face' && (
                    <SearchFace
                        apiUrl={`${API_BASE_URL}/searchface`}
                        onResults={handleResults}
                    />
                )}
            </div>

            {searchResults && (
                <ResultsGallery
                    results={searchResults}
                    s3Host={S3_HOST}
                />
            )}
            {/* 4. ¡COLOCAR AQUÍ EL CARRUSEL! */}
            <HighlightsCarousel />

            <footer className="app-footer-container">
                {/* 2. Contenido del Encabezado (texto, logo, etc.) */}
                <div className="app-footer-content">
                    <img
                        src="/Logotipo-FotoRun-footer.svg"
                        alt="FOTORUN - Capturando tus logros"
                        className="footer-logo"
                    />

                    <div className="contact-links">
                        <a href="mailto:contacto@fotorun.mx" target="_blank" rel="noopener noreferrer" className="contact-item">
                            <Mail size={24} />
                            <span>contacto@fotorun.mx</span>
                        </a>
                        <a href="https://wa.me/528332329231" target="_blank" rel="noopener noreferrer" className="contact-item">
                            <MessageCircle size={24} />
                            <span>+52 833 232 9231</span>
                        </a>
                        <a href="https://instagram.com/fotorun.mx" target="_blank" rel="noopener noreferrer" className="contact-item">
                            <Instagram size={24} />
                            <span>@fotorun.mx</span>
                        </a>
                    </div>

                    <a 
                    href={MERCADO_PAGO_LINK} 
                    target="_blank" // ESTO ES LA CLAVE: Abre una nueva pestaña/ventana
                    rel="noopener noreferrer"
                    className="primary-action-button" 
                    title="Apoya el mantenimiento de la aplicación"
                >
                    Dar un Donativo
                </a>

                    <div className="copyright">
                        <p>&copy; {new Date().getFullYear()} Fotorun MX. Todos los derechos reservados.</p>
                    </div>

                    
                </div>
            </footer>

        </div>
    );
}

export default App;